import React from 'react'
//import { LOCATION_LABELS } from '../utils/const'
//import { ExpandMore } from '@mui/icons-material'
import OutlinedInput from '@mui/material/OutlinedInput'
import ListSubheader from '@mui/material/ListSubheader'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
//import styled from 'styled-components'
import { useTranslation } from 'gatsby-plugin-react-i18next'

//import { OptionModel } from '../../utils/model'
//import { convert } from 'html-to-text'

// const StyledItem = styled.div`
//   opacity: 0.5;
// `
//const StyledSelect = styled(Select)`
// .MuiPaper-root {
//   max-height: 13rem;
// }
// .MuiList-root {
//   background-color: var(--brightBlue);
//   color: white;
// }
// .MuiListSubheader-root {
//   background-color: var(--brightBlue) !important;
//   color: white !important;
//   font-size: 1rem !important;
// }
//`
const SingleSelect = ({
  whoOptions,
  incOptions,
  uniOptions,
  value,
  onChange,
  queryKey
}) => {
  const { t } = useTranslation()
  const handleChange = (event) => {
    const {
      target: { value }
    } = event
    // onChange({ [queryKey]: value })
    onChange(value)
  }
  return (
    <FormControl sx={{ mt: 1, mb: 1, width: '100%' }}>
      <Select
        id="single"
        //IconComponent={ExpandMore}
        input={<OutlinedInput />}
        value={value}
        onChange={handleChange}
      >
        <MenuItem key="global" value="GBL">
          {t('Global — All Regions')}
        </MenuItem>
        {whoOptions && <ListSubheader>{t('WHO Regions')}</ListSubheader>}

        {whoOptions?.map((option) => (
          <MenuItem
            key={option.id}
            value={option.id}
            sx={{ paddingLeft: '2rem' }}
            disabled={option.disabled}
          >
            {t(option.label)}
          </MenuItem>
        ))}
        {uniOptions && (
          <ListSubheader>{t('UNICEF Programme Regions')}</ListSubheader>
        )}
        {uniOptions?.map((option) => (
          <MenuItem
            key={option.id}
            value={option.id}
            sx={{
              paddingLeft: '2rem'
            }}
            disabled={option.disabled}
          >
            {t(option.label)}
          </MenuItem>
        ))}

        {incOptions && (
          <ListSubheader>{t('World Bank Income Classification')}</ListSubheader>
        )}

        {incOptions?.map((option) => (
          <MenuItem
            key={option.id}
            value={option.id}
            sx={{
              paddingLeft: '2rem'
            }}
            disabled={option.disabled}
          >
            {t(option.label)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default SingleSelect
